import { GlobalController } from 'src/shared/global/GlobalController'
import User from './User'
const ifAuthenticated = (to, from, next) => {
  GlobalController.getAsyncInstance().then(data => {
    if (data && data.authResp && data.authResp.token) {
      next()
    } else {
      next('/')
    }
  })
}
export const routes = [
  {
    path: 'user',
    name: 'user',
    component: User,
    beforeEnter: ifAuthenticated,
    props: true
  }
]
